console.log('CUSTOM JS LOADED')
document.addEventListener('DOMContentLoaded', () => {
  // unselectAllVariants();
  function getScope (el) {
    return el.closest('.quick-add, .modal, .drawer') || document
  }
  function getPageSelectedValue () {
    const checkedInput = document.querySelector(
      'input.pro_var_input:checked[data-value]'
    )
    if (checkedInput) {
      const val = checkedInput.getAttribute('data-value')
      return val
    }
    return null
  }

  function syncVariantState (scope = document) {
    const buttons = scope.querySelectorAll('.sg-variant-btn[data-value]')
    const rows = scope.querySelectorAll('.table-row-list[data-row-name]')

    const buttonMap = new Map()

    buttons.forEach(btn => {
      const value = btn.getAttribute('data-value')
      if (!value) return
      buttonMap.set(value, {
        isDisabled: btn.classList.contains('disabled'),
        isSelected: btn.classList.contains('selected')
      })
    })

    rows.forEach(row => {
      const rowValue = row.getAttribute('data-row-name')
      row.classList.remove('hidden', 'disabled', 'selected')

      if (!buttonMap.has(rowValue)) {
        row.classList.add('hidden')
      } else {
        const data = buttonMap.get(rowValue)
        if (data.isDisabled) row.classList.add('disabled')
        if (data.isSelected) row.classList.add('selected')
      }
    })
  }

  function clearSelection (scope = document) {
    scope
      .querySelectorAll('.sg-variant-btn.selected, .table-row-list.selected')
      .forEach(el => el.classList.remove('selected'))
  }

  function triggerInputByValue (value, scope = document) {
    let input = document.querySelector(
      `input.pro_var_input[data-value="${value}"]`
    )

    if (input) {
      input.checked = true
      input.dispatchEvent(new Event('change', { bubbles: true }))
      input.dispatchEvent(new Event('input', { bubbles: true }))
    } else {
      console.warn(`[SizeChart] No input found for data-value: ${value}`)
    }
  }

  function syncSelectedVariantToPopup (popup) {
    if (!popup) return

    const selectedValue = getPageSelectedValue()
    if (!selectedValue) {
      syncVariantState(popup)
      return
    }

    clearSelection(popup)

    const btn = popup.querySelector(
      `.sg-variant-btn[data-value="${selectedValue}"]`
    )
    const row = popup.querySelector(
      `.table-row-list[data-row-name="${selectedValue}"]`
    )

    if (btn) btn.classList.add('selected')
    if (row) row.classList.add('selected')

    syncVariantState(popup)
  }

  function updateSizeGuidePrice(variantId, scope = document) {
  if (!variantId) return

  const variant = window.productVariants?.find(
    variant => String(variant.id) === String(variantId)
  )

  if (!variant) {
    console.log('Variant not found:', variantId)
    return
  }

  const priceContainer = scope.querySelector('.sg-product-price')

  if (!priceContainer) {
    console.log('Size guide price container not found')
    return
  }

  const formatMoney = cents => {
    return Shopify.formatMoney(
      cents,
      window.money_format || '${{amount}}'
    )
  }

  const priceHTML = `
    <div class="price-list">
      <span class="price-item price-item--regular">
        ${formatMoney(variant.price)}
      </span>
      ${
        variant.compare_at_price > variant.price
          ? `<span class="price-item price-item--compare">
              <s>${formatMoney(variant.compare_at_price)}</s>
            </span>`
          : ''
      }
    </div>
  `

  priceContainer.innerHTML = priceHTML
}

function selectByValue(value, scope = document) {
  if (!value) return

  clearSelection(scope)

  const btn = scope.querySelector(
    `.sg-variant-btn[data-value="${CSS.escape(value)}"]`
  )

  const row = scope.querySelector(
    `.table-row-list[data-row-name="${CSS.escape(value)}"]`
  )

  if (btn) {
    btn.classList.add('selected')

    updateSizeGuidePrice(btn)
  }

  if (row) {
    row.classList.add('selected')
  }

  triggerInputByValue(value, scope)

  syncVariantState(scope)
}

function updateSizeGuidePrice(btn) {
  if (!btn) return

  const priceContainer = btn.closest('.sg-product-info')?.querySelector('.sg-product-price')

  if (!priceContainer) {
    console.log('Size guide price container not found')
    return
  }

  const price = Number(btn.dataset.price || 0)
  const comparePrice = Number(btn.dataset.comparePrice || 0)

  const salePrice = priceContainer.querySelector(
    'sale-price .money'
  )

  const compareAtPrice = priceContainer.querySelector(
    'compare-at-price .money'
  )

  const discountElement = priceContainer.querySelector(
    '.discount-percentage'
  )

  if (!salePrice) {
    console.log('Sale price element not found')
    return
  }

 const formatMoney = cents => {
  const amount = (Number(cents) / 100).toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })

  const template = window.money_format || '{{amount}}'

  const temp = document.createElement('div')
  temp.innerHTML = template.replace('{{amount}}', amount)

  return temp.textContent.trim()
}

  salePrice.textContent = formatMoney(price)

  if (compareAtPrice) {
    if (comparePrice > price) {
      compareAtPrice.textContent = formatMoney(comparePrice)
      compareAtPrice.parentElement.style.display = ''
    } else {
      compareAtPrice.textContent = ''
      compareAtPrice.parentElement.style.display = 'none'
    }
  }

  if (discountElement) {
    if (comparePrice > price) {
      const discount = Math.round(
        ((comparePrice - price) / comparePrice) * 100
      )

      discountElement.textContent = `(${discount}% OFF)`
      discountElement.style.display = ''
    } else {
      discountElement.style.display = 'none'
    }
  }

  console.log('Size guide price updated:', {
    variantId: btn.dataset.variantId,
    price,
    comparePrice
  })
}

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return

        if (
          (node.classList?.contains('modal') ||
            node.classList?.contains('drawer')) &&
          node.hasAttribute('open')
        ) {
          setTimeout(() => syncSelectedVariantToPopup(node), 100)
        }

        const popup = node.closest?.('.modal[open], .drawer[open]')
        if (popup) {
          setTimeout(() => syncSelectedVariantToPopup(popup), 100)
        }
      })

      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'open' &&
        mutation.target.hasAttribute('open')
      ) {
        const popup = mutation.target
        if (
          popup.classList.contains('modal') ||
          popup.classList.contains('drawer')
        ) {
          setTimeout(() => syncSelectedVariantToPopup(popup), 100)
        }
      }
    })
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  })

  document.addEventListener('click', e => {
    const btn = e.target.closest('.sg-variant-btn[data-value]')
    if (btn) {
      e.stopPropagation()
      if (btn.classList.contains('disabled')) return
      selectByValue(btn.getAttribute('data-value'), getScope(btn))
      return
    }

    const row = e.target.closest('.table-row-list[data-row-name]')
    if (row) {
      e.stopPropagation()
      if (row.classList.contains('disabled')) return
      selectByValue(row.getAttribute('data-row-name'), getScope(row))
      return
    }

    const submitBtn = e.target.closest('.variant-list-submit-buton')
    if (submitBtn) {
      e.stopPropagation()
      const scope = getScope(submitBtn)
      const selectedBtn = scope.querySelector(
        '.sg-variant-btn.selected[data-value]'
      )
      if (selectedBtn) {
        const value = selectedBtn.getAttribute('data-value')
        triggerInputByValue(value, scope)

        const modal = submitBtn.closest('.modal, .drawer')
        if (modal) {
          modal.removeAttribute('open')
          modal.dispatchEvent(new Event('close', { bubbles: true }))
        }
      }
      return
    }

    setTimeout(() => {
      const openPopup = document.querySelector('.modal[open], .drawer[open]')
      if (openPopup) {
        syncSelectedVariantToPopup(openPopup)
      }
    }, 200)
  })
  syncVariantState()
  document.addEventListener('shopify:section:load', () => {
    syncVariantState()
  })
})

function initSgTabs (root = document) {
  const tabContainers = root.querySelectorAll('.top-barright-col')
  if (!tabContainers.length) return

  tabContainers.forEach(container => {
    // already initialized check — double init અટકાવે
    if (container.dataset.sgTabInit) return
    container.dataset.sgTabInit = 'true'

    const buttons = container.querySelectorAll('.sg-tab-button')
    const infos = container.querySelectorAll('.sg-tab-info')

    if (!buttons.length || !infos.length) return

    function activateTab (tabName) {
      buttons.forEach(btn => btn.classList.remove('active'))
      infos.forEach(info => info.classList.remove('active'))

      const activeBtn = container.querySelector(
        `.sg-tab-button[data-tab-name="${tabName}"]`
      )
      const activeInfo = container.querySelector(
        `.sg-tab-info[data-info-name="${tabName}"]`
      )

      if (activeBtn) activeBtn.classList.add('active')
      if (activeInfo) activeInfo.classList.add('active')
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', function () {
        const tabName = this.getAttribute('data-tab-name')
        activateTab(tabName)
      })
    })

    const firstTab = buttons[0].getAttribute('data-tab-name')
    activateTab(firstTab)
  })
}

// Page load વખતે
document.addEventListener('DOMContentLoaded', () => initSgTabs())

// Popup reopen વખતે — નવો DOM detect કરે
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return // element જ જોઈએ
      // popup wrapper હોય તો અંદર tabs init કરો
      if (node.querySelector?.('.top-barright-col')) {
        initSgTabs(node)
      }
    })
  })
})

observer.observe(document.body, { childList: true, subtree: true })

document.addEventListener('click', e => {
  const btn = e.target.closest('.size-switch')
  if (!btn) return

  const scope = btn.closest('.modal, .drawer, .quick-add') || document

  const switches = scope.querySelectorAll('.size-switch')
  const table = scope.querySelector('.size-chart-table')
  switches.forEach(el => el.classList.remove('active'))
  btn.classList.add('active')
  if (table) {
    if (btn.classList.contains('size-switch-cm')) {
      table.classList.add('cm-size-show')
    } else {
      table.classList.remove('cm-size-show')
    }
  }
})

document.addEventListener('click', function (e) {
  const toggleBtn = e.target.closest('.mobile-show-hide-button')
  if (toggleBtn) {
    toggleBtn.classList.toggle('active')
    return
  }
  const listBtn = e.target.closest('.mobile-list-button')
  if (listBtn) {
    const target = document.querySelector('.col.left-col')
    if (target) {
      target.classList.toggle('active')
    }
  }
})

document.addEventListener('click', function (e) {
  const button = e.target.closest('.popup-footer-button')
  if (!button) return
  document.dispatchEvent(
    new KeyboardEvent('keydown', {
      key: 'Escape',
      bubbles: true
    })
  )
})

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.down_button_option_button').forEach((button) => {
//     button.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();
//       const parentItem = this.closest('.mobile-menulist');
//       const dropdown = parentItem.querySelector('.mobile-menu-dropdown-value');
//       if (dropdown) {
//         dropdown.classList.toggle('active');
//       }
//     });
//   });
// });
;(() => {
  const input = document.querySelector('.pincode_checker_input')
  const button = document.querySelector('.pincode_checker_button')
  const msg = document.querySelector('.pincode_checker_msg')
  if (!input || !button || !msg) return

  const addBusinessDays = (date, days, excludeSaturday = false) => {
    let count = 0
    let d = new Date(date)
    while (count < days) {
      d.setDate(d.getDate() + 1)
      const day = d.getDay()
      if (excludeSaturday) {
        if (day !== 0 && day !== 6) count++
      } else {
        if (day !== 0) count++
      }
    }
    return d
  }

const formatDate = date => {
  const day = date.toLocaleDateString('en-US', { weekday: 'long' })
  const dd = date.getDate()
  const month = date.toLocaleDateString('en-US', { month: 'short' })
  const year = date.getFullYear()

  return `${day}, ${dd} ${month} ${year}`
}

  const showMsg = (text, type) => {
    msg.textContent = text
    msg.className = `pincode_checker_msg ${type}`
    msg.style.display = 'block'
  }

  input.addEventListener('input', () => {
    input.value = input.value.replace(/\D/g, '').slice(0, 6)
    msg.style.display = 'none'
  })

  const checkPin = (isInitialLoad = false) => {
    let baseDays
    const wrapper = document.querySelector('.pincode_checker_msg')
    if (!wrapper) return
    const value = input.value.trim()

    let isValidIndianPin

    if (value.length > 0) {
      // User entered a pincode
      isValidIndianPin = /^[1-9][0-9]{5}$/.test(value)

      if (!isValidIndianPin) {
        return showMsg('⚠️ Please enter a valid Indian pincode.', 'warning')
      }
    } else {
      // Initial page load / no pincode entered
      isValidIndianPin = wrapper.dataset.country === 'IN'
    }
    const today = new Date()
    const hasMTO = wrapper.dataset.mto === 'true'
    const rtsDays = Number(wrapper.dataset.rts || 4)
    const shippingDays = Number(wrapper.dataset.shipping || 4)

    // Selected variant
    const selectedVariant = document.querySelector('.pro_var_input:checked')

    let variantAvailable = null
    let variantHasMTO = null

    if (selectedVariant) {
      // Variant availability metafield
      const variantAvailableValue = selectedVariant.dataset.variantAvailable

      if (variantAvailableValue !== undefined && variantAvailableValue !== '') {
        variantAvailable = variantAvailableValue === 'true'
      }

      // Variant MTO metafield
      const variantMtoValue = selectedVariant.dataset.variantMto

      if (variantMtoValue !== undefined && variantMtoValue !== '') {
        variantHasMTO = variantMtoValue === 'true'
      }
    }

    // Tab states
    const hasTabs = !!document.querySelector('.addon-main-tab-wrap')

    const isUnstitched = document
      .querySelector('.unstitched-tab-button')
      ?.classList.contains('active')

    // Initial page load → always use RTS
    const hasRts =
      wrapper.dataset.rts !== '' &&
      wrapper.dataset.rts !== undefined &&
      Number(wrapper.dataset.rts) > 0

    if (isInitialLoad && hasRts) {
      baseDays = rtsDays
    } else if (variantAvailable !== null) {
      // Variant metafield exists

      if (variantAvailable === false) {
        baseDays = shippingDays
      } else {
        if (variantHasMTO === true) {
          baseDays = shippingDays
        } else {
          if (hasTabs) {
            baseDays = isUnstitched ? rtsDays : shippingDays
          } else {
            baseDays = rtsDays
          }
        }
      }
    } else {
      // Product-level fallback

      baseDays = hasTabs
        ? isUnstitched
          ? rtsDays
          : shippingDays
        : hasMTO
        ? shippingDays
        : rtsDays
    }

    const totalDays = isValidIndianPin ? baseDays : baseDays + 4

    // Estimated delivery date from today
    const deliveryDate = addBusinessDays(today, totalDays, !isValidIndianPin)
    console.log({
      today: today.toDateString(),
      isValidIndianPin,
      rtsDays,
      shippingDays,
      baseDays,
      totalDays,
      excludeSaturday: !isValidIndianPin
    })

    showMsg(`✓ Estimated Delivery on ${formatDate(deliveryDate)}`, 'success')
    let edd_product_property = document.querySelector('.edd_product_property')
    if (edd_product_property) {
      edd_product_property.value = formatDate(deliveryDate)
    }
    let edd_base_days_property = document.querySelector('.edd_base_days_property')
    if (edd_base_days_property) {
      edd_base_days_property.value = baseDays
    }
    let edd_is_indian_property = document.querySelector('.edd_is_indian_property')
    if (edd_is_indian_property) {
      edd_is_indian_property.value = isValidIndianPin
    }
  }

  button.addEventListener('click', () => checkPin())

  // // Recalculate automatically on variant change
  // document.addEventListener('change', (e) => {

  //   const variantInput = e.target.closest('.pro_var_input');

  //   if (!variantInput) return;
  //   // only rerun if pincode already entered
  //   if (input.value.trim().length > 0) {

  //     checkPin();
  //   }

  // });

  // Auto recalculate on stitched/unstitched switch
  document.addEventListener('click', e => {
    const tabBtn = e.target.closest(
      '.unstitched-tab-button, .stitched-tab-button'
    )

    if (!tabBtn) return
  })

  checkPin(true)

  document.addEventListener('change', e => {
    if (e.target.closest('.pro_var_input')) {
      checkPin()
    }
  })
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      e.preventDefault()
      checkPin()
    }
  })

  document.addEventListener('click', e => {
    if (
      e.target.closest('.stitched-tab-button') ||
      e.target.closest('.unstitched-tab-button')
    ) {
      setTimeout(() => checkPin(), 50)
    }
  })
})()

function calculateWishlistDeliveryDays ({
  variantAvailable = null,
  variantHasMTO = null,
  hasTabs = false,
  isUnstitched = false,
  hasMTO = false,
  rtsDays = 0,
  shippingDays = 0
}) {
  let baseDays

  /*
   * --------------------------------
   * VARIANT METAFIELD EXISTS
   * --------------------------------
   */

  if (variantAvailable !== null) {
    /*
     * Variant IsVariantAvailable = false
     * → SHIPPING DAYS
     */
    if (variantAvailable === false) {
      baseDays = shippingDays
    } else {
      /*
       * Variant IsVariantAvailable = true
       */

      /*
       * Variant MTO = true
       * → SHIPPING DAYS
       */
      if (variantHasMTO === true) {
        baseDays = shippingDays
      } else {
        /*
         * Variant MTO = false
         */

        if (hasTabs) {
          /*
           * Tabs exist
           */

          if (isUnstitched) {
            // Unstitched → RTS
            baseDays = rtsDays
          } else {
            // Stitched → SHIPPING
            baseDays = shippingDays
          }
        } else {
          /*
           * No tabs → RTS
           */
          baseDays = rtsDays
        }
      }
    }
  } else {
    /*
     * --------------------------------
     * VARIANT METAFIELD NOT PRESENT
     * --------------------------------
     */

    if (hasTabs) {
      if (isUnstitched) {
        // Unstitched → RTS
        baseDays = rtsDays
      } else {
        // Stitched → SHIPPING
        baseDays = shippingDays
      }
    } else {
      if (hasMTO) {
        // Product MTO → SHIPPING
        baseDays = shippingDays
      } else {
        // Product MTO false → RTS
        baseDays = rtsDays
      }
    }
  }

  return baseDays
}

/* =========================================
   WISHLIST EDD DATE HELPERS
   ========================================= */

function addWishlistBusinessDays (date, days, excludeSaturday = false) {
  let count = 0

  const d = new Date(date)

  while (count < days) {
    d.setDate(d.getDate() + 1)

    const day = d.getDay()

    if (excludeSaturday) {
      // Sunday + Saturday excluded
      if (day !== 0 && day !== 6) {
        count++
      }
    } else {
      // Sunday excluded
      if (day !== 0) {
        count++
      }
    }
  }

  return d
}

function formatWishlistDate(date) {
  return `${date.toLocaleDateString('en-US', { weekday: 'long' })}, ${date.getDate()} ${date.toLocaleDateString('en-US', { month: 'short' })} ${date.getFullYear()}`
}

/* =========================================
   WISHLIST VARIANT ID
   ========================================= */

function getWishlistVariantId (product) {
  /*
   * iWish stores the variant ID in:
   * product_var{variantId}
   */

  const productId = product.id || ''

  if (productId.startsWith('product_var')) {
    return productId.replace('product_var', '')
  }

  /*
   * Fallback 1
   */

  const variantElement = product.querySelector('[data-variant-id]')

  if (variantElement) {
    const variantId = variantElement.dataset.variantId

    if (variantId) {
      return variantId
    }
  }

  /*
   * Fallback 2
   */

  const variantData = product.querySelector('[data-variant]')

  if (variantData) {
    const variantId = variantData.dataset.variant

    if (variantId) {
      return variantId
    }
  }

  /*
   * Fallback 3
   * Variant from URL
   */

  const variantLink = product.querySelector('a[href*="variant="]')

  if (variantLink) {
    try {
      const url = new URL(variantLink.href, window.location.origin)

      const variantId = url.searchParams.get('variant')

      if (variantId) {
        return variantId
      }
    } catch (e) {
      console.warn('Could not read wishlist variant ID', e)
    }
  }

  /*
   * Fallback 4
   */

  const input = product.querySelector('input[name="id"]')

  if (input?.value) {
    return input.value
  }

  console.warn('Wishlist variant ID not found', product)

  return null
}

/* =========================================
   WISHLIST VARIANT LABEL (e.g. "XS", "2XL")
   ========================================= */

function getWishlistVariantLabel (product) {
  const label = product
    .querySelector('.product-variant-wrapper .product-variant')
    ?.textContent?.trim()

  return label || null
}

/* =========================================
   WISHLIST EDD
   ========================================= */

function calculateWishlistEDD (baseDays, country) {
  if (!baseDays || baseDays <= 0) {
    return null
  }

  const isIndian = country === 'IN'

  const totalDays = isIndian ? baseDays : baseDays + 4

  /*
   * IMPORTANT:
   * This is TODAY at the moment
   * wishlist EDD is calculated.
   */

  const today = new Date()

  const deliveryDate = addWishlistBusinessDays(today, totalDays, !isIndian)

  return formatWishlistDate(deliveryDate)
}
async function appendWishlistEDD () {
  const wishlistProducts = document.querySelectorAll('.iwishProduct-row')

  console.log('Wishlist EDD - Products:', wishlistProducts.length)

  if (!wishlistProducts.length) return

  wishlistProducts.forEach(async product => {
    /*
     * Prevent duplicate rendering
     */
    if (
      product.querySelector('.wishlist-edd') ||
      product.dataset.eddLoading === 'true'
    ) {
      return
    }

    /*
     * Lock before fetch
     */
    product.dataset.eddLoading = 'true'

    try {
      /*
       * --------------------------------
       * PRODUCT HANDLE
       * --------------------------------
       */

      const handle = product.querySelector('[data-handle]')?.dataset.handle

      if (!handle) {
        console.warn('Wishlist handle not found', product)
        return
      }

      /*
       * --------------------------------
       * EXACT WISHLIST VARIANT
       * --------------------------------
       */

      const variantId = getWishlistVariantId(product)
      const variantLabel = getWishlistVariantLabel(product)

      console.log('Wishlist variant:', {
        handle,
        variantId,
        variantLabel
      })

      if (!variantId && !variantLabel) {
        console.warn('Wishlist variant not found:', handle)
        return
      }

      /*
       * --------------------------------
       * FETCH PRODUCT PAGE
       * --------------------------------
       */

      const response = await fetch(`/products/${handle}`)

      if (!response.ok) {
        throw new Error(`Product fetch failed: ${response.status}`)
      }

      const html = await response.text()

      /*
       * --------------------------------
       * PARSE PRODUCT HTML
       * --------------------------------
       */

      const parser = new DOMParser()

      const doc = parser.parseFromString(html, 'text/html')

      /*
       * --------------------------------
       * PRODUCT LEVEL EDD DATA
       * --------------------------------
       */

      const sourceWrapper = doc.querySelector('.pincode_checker_msg')

      if (!sourceWrapper) {
        console.warn('Wishlist EDD source not found:', handle)
        return
      }

      const rtsDays = Number(sourceWrapper.dataset.rts || 0)

      const shippingDays = Number(sourceWrapper.dataset.shipping || 0)

      const hasMTO = sourceWrapper.dataset.mto === 'true'

      const country = sourceWrapper.dataset.country || 'IN'

      /*
       * --------------------------------
       * FIND EXACT VARIANT
       * --------------------------------
       */

      let selectedVariant = null

      /*
       * Primary match: the visible size label ("XS", "2XL", ...)
       * — this is the same data-value attribute used everywhere
       * else in this file to identify a variant, and it's reliably
       * present on both the wishlist row and the PDP's pro_var_input.
       */
      if (variantLabel) {
        selectedVariant = doc.querySelector(
          `.pro_var_input[data-value="${variantLabel}"]`
        )
      }

      if (!selectedVariant && variantId) {
        selectedVariant = doc.querySelector(
          `.pro_var_input[value="${variantId}"]`
        )
      }

      if (!selectedVariant && variantId) {
        selectedVariant = doc.querySelector(
          `.pro_var_input[data-variant-id="${variantId}"]`
        )
      }

      console.log('Matched wishlist variant element:', selectedVariant)

      /*
       * --------------------------------
       * VARIANT METAFIELDS
       * --------------------------------
       */

      let variantAvailable = null
      let variantHasMTO = null

      if (selectedVariant) {
        const available = selectedVariant.dataset.variantAvailable

        if (available !== undefined && available !== '') {
          variantAvailable = available === 'true'
        }

        const mto = selectedVariant.dataset.variantMto

        if (mto !== undefined && mto !== '') {
          variantHasMTO = mto === 'true'
        }
      }

      /*
       * --------------------------------
       * TAB STATE
       * --------------------------------
       */

      const hasTabs = !!doc.querySelector('.addon-main-tab-wrap')

      const isUnstitched = doc
        .querySelector('.unstitched-tab-button')
        ?.classList.contains('active')

      /*
       * --------------------------------
       * CLIENT DELIVERY LOGIC
       * --------------------------------
       */

      const baseDays = calculateWishlistDeliveryDays({
        variantAvailable,
        variantHasMTO,
        hasTabs,
        isUnstitched,
        hasMTO,
        rtsDays,
        shippingDays
      })

      console.log('Wishlist EDD calculation:', {
        handle,
        variantId,
        variantAvailable,
        variantHasMTO,
        hasTabs,
        isUnstitched,
        hasMTO,
        rtsDays,
        shippingDays,
        baseDays,
        country
      })

      /*
       * --------------------------------
       * CALCULATE FROM TODAY
       * --------------------------------
       */

      const formattedDate = calculateWishlistEDD(baseDays, country)

      if (!formattedDate) {
        console.warn('Invalid wishlist EDD:', handle)

        return
      }

      /*
       * --------------------------------
       * CREATE EDD
       * --------------------------------
       */

      const edd = document.createElement('div')

      edd.className = 'wishlist-edd'

      edd.textContent = `Estimated Delivery: ${formattedDate}`

      /*
       * --------------------------------
       * INSERT AFTER PRICE
       * --------------------------------
       */

      const priceContainer = product.querySelector('.price_Container')

      if (priceContainer) {
        priceContainer.after(edd)
      } else {
        console.warn('.price_Container not found:', handle)
      }
    } catch (error) {
      console.error('Wishlist EDD error:', error)
    } finally {
      /*
       * Always release loading lock
       */
      product.dataset.eddLoading = 'false'
    }
  })
}
/* =========================================
   WISHLIST EDD INITIALIZATION
   ========================================= */

(function initWishlistEDD() {

  let wishlistTimer = null;

  function runWishlistEDD() {

    clearTimeout(wishlistTimer);

    wishlistTimer =
      setTimeout(() => {

        const wishlistProducts =
          document.querySelectorAll(
            ".iwishProduct-row"
          );

        if (
          !wishlistProducts.length
        ) {
          return;
        }

        console.log(
          "Running Wishlist EDD..."
        );

        appendWishlistEDD();

      }, 150);
  }


  /*
   * Initial page load
   */

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      runWishlistEDD
    );

  } else {

    runWishlistEDD();

  }


  /*
   * iWish dynamically creates/replaces
   * wishlist drawer content.
   */

  const wishlistObserver =
    new MutationObserver(
      (mutations) => {

        let wishlistChanged = false;

        mutations.forEach(
          (mutation) => {

            mutation.addedNodes.forEach(
              (node) => {

                if (
                  node.nodeType !== 1
                ) {
                  return;
                }

                /*
                 * Direct wishlist row
                 */

                if (
                  node.matches?.(
                    ".iwishProduct-row"
                  )
                ) {

                  wishlistChanged = true;

                }


                /*
                 * Wishlist rows inside
                 * newly added content
                 */

                if (
                  node.querySelector?.(
                    ".iwishProduct-row"
                  )
                ) {

                  wishlistChanged = true;

                }

              }
            );

          }
        );


        if (wishlistChanged) {
          runWishlistEDD();
        }

      }
    );


  wishlistObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();


// EDD CART INTEGRATION STARTS
window.addCartBusinessDays = function(date, days, excludeSaturday = false) {
  let count = 0
  const d = new Date(date)

  while (count < days) {
    d.setDate(d.getDate() + 1)

    const day = d.getDay()

    if (excludeSaturday) {
      if (day !== 0 && day !== 6) {
        count++
      }
    } else {
      if (day !== 0) {
        count++
      }
    }
  }

  return d
}

window.formatCartEDDDate = function(date) {
  const day = date.toLocaleDateString('en-US', { weekday: 'long' })
  const dd = date.getDate()
  const month = date.toLocaleDateString('en-US', { month: 'short' })
  const year = date.getFullYear()

  return `${day}, ${dd} ${month} ${year}`
}

window.return_latest_estimation_date = function(
  baseDays,
  isIndian
) {
  const totalDays = isIndian
    ? baseDays
    : baseDays + 4

  const today = new Date()

  const deliveryDate = window.addCartBusinessDays(
    today,
    totalDays,
    !isIndian
  )

  return window.formatCartEDDDate(deliveryDate)
}

window.update_estimation_date = async function() {
  const cart_items = document.querySelectorAll(".cart-drawer__items .line-item");
  const need_to_update_items = [];

  cart_items.forEach((cart_item) => {
    const current_edd = cart_item.dataset.edd;
    if (!current_edd) return;

    const variant_id = cart_item.dataset.variant_id;
    const baseDays = Number(cart_item.dataset.baseDays);
    const isIndian = cart_item.dataset.isIndian === 'true';
    const line_key = cart_item.dataset.lineKey;

    if (!cart_item.dataset.baseDays) return;

    const latest_edd_date = return_latest_estimation_date(
      baseDays,
      isIndian
    );

    if (current_edd !== latest_edd_date) {
      need_to_update_items.push({
        line_key,
        variant_id,
        new_edd: latest_edd_date
      });
    }
  });

  if (!need_to_update_items.length) return;

  console.log("Need to update:", need_to_update_items);

  let updated_count = 0;
  const total_update_count = need_to_update_items.length;

  for (const item of need_to_update_items) {
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: item.line_key,
          properties: {
            "Estimated Delivery": item.new_edd
          }
        })
      });

      if (!response.ok) {
        throw new Error(`Failed to update ${item.variant_id}`);
      }

      updated_count++;

      console.log(
        `EDD updated ${updated_count}/${total_update_count}`,
        item.variant_id,
        item.new_edd
      );

    } catch (error) {
      console.error("EDD update failed:", item.variant_id, error);
    }
  }

  if (updated_count === total_update_count) {
    if(__st.p == 'cart'){
      window.location.reload();
    }else{
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
  }
}

document.querySelectorAll('a[href="/cart"][aria-controls="cart-drawer"]').forEach(function (cartLink) {
  cartLink.addEventListener('click', function () {
    update_estimation_date();
  });
});
if(__st.p == 'cart'){
   update_estimation_date();
}


// EDD CART INTEGRATION ENDS





// similkar products logic starts 

function show_similar_products(element) {
  const selectedSize = element.dataset.size?.trim().toUpperCase();

  if (!selectedSize) return;

  const similarSlider = document.querySelector('.related-products-slider');

  if (!similarSlider) return;

  const similarSection = similarSlider.closest('.section-stack');

  const heading = similarSection?.querySelector('.prose h2');

  if (heading) {
    heading.textContent = `Similar Products - ${selectedSize}`;
  }

  const products = similarSlider.querySelectorAll(
    '.swiper-wrapper > .product-slide'
  );

  products.forEach((product) => {
    const optionGroup = product.querySelector(
      '.product-size-popup .option-group.flexbox'
    );

    let hasSelectedSize = false;

    if (optionGroup) {
      const variantButtons = optionGroup.querySelectorAll('.variant-btn');

      variantButtons.forEach((button) => {
        button.classList.remove('similar-size-selected');

        const variantSize =
          button.dataset.val?.trim().toUpperCase() ||
          button.querySelector('.variant-btn-text')?.textContent
            .trim()
            .toUpperCase();

        if (variantSize === selectedSize) {
          hasSelectedSize = true;
          button.classList.add('similar-size-selected');
        }
      });
    }

    product.classList.toggle(
      'similar-product-hidden',
      !hasSelectedSize
    );
  });

  if (similarSection) {
    const headerOffset = 100;

    const sectionTop =
      similarSection.getBoundingClientRect().top +
      window.pageYOffset -
      headerOffset;

    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth'
    });
  }
}

window.show_similar_products = show_similar_products;
// similar products logic ends 